import * as React from 'react';
import {
  usePageSpeedIconWithAction,
  useSpeedDealMenuOpened,
} from '@dpdgroupuk/fmx-ui/components/Page/hooks';
import { isMobile } from '@dpdgroupuk/fmx-ui/utils/helpers';

import { Chat } from '../../components/Icons';

const createChatIconWithAction = ({
  setShowChat,
  showChat,
  showChatIcon,
  loadChat,
  setLoadChat,
}) => {
  const action = () => {
    if (!loadChat) {
      setLoadChat(true);
      setShowChat(true);
    } else {
      setShowChat(!showChat);
    }
  };
  return showChatIcon ? [Chat, action] : [];
};

export const useChatIconWithAction = ({
  setShowChat,
  showChat,
  setLoadChat,
  loadChat,
  showChatIcon,
  chatOrigin,
}) => {
  const iconWithAction = React.useMemo(
    () =>
      createChatIconWithAction({
        setShowChat,
        showChat,
        loadChat,
        setLoadChat,
        showChatIcon,
      }),
    [setShowChat, showChat, loadChat, setLoadChat, showChatIcon]
  );
  usePageSpeedIconWithAction(iconWithAction);
  useSpeedDealMenuOpened(showChat ? false : isMobile ? chatOrigin : true);
};

export const useDelay = chatbotButtonDelay => {
  const [delay, setDelay] = React.useState(false);
  const isMounted = React.useRef(false);
  const time = parseInt(chatbotButtonDelay);

  React.useEffect(() => {
    isMounted.current = true;

    setTimeout(() => {
      if (isMounted.current) {
        setDelay(true);
      }
    }, time);

    return () => {
      isMounted.current = false;
    };
  }, [time]);

  return delay;
};
